import React, { Fragment, useEffect, useState } from 'react';
import './dashboard-settings.container.sass';
import { DashboardSettingsForm } from './form/dashboard-settings-form';
import { getSession } from '../../login/session.slice';
import { Preloader } from '../../../components/interface/preloader/preloader';
import { useDispatch } from 'react-redux';

export const DashboardSettingsContainer = () => {

  const [isFetching, setIsFetching] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSession({})).then( () => {
      setIsFetching(false);
    });
  }, []);

  return (
    <div className='vv-dashboard-settings-container'>
      {isFetching ? <Preloader/> : <DashboardSettingsForm/>}
    </div>
  );
};
